export default __webpack_public_path__ + "static/WebUI-MenuVideoBar_Zoom-6c1779ce272bc60b63aa6035a25b1654.png";